import {
  ServiceDev,
  ServiceLocalizeProd,
  ServiceMock,
  ServiceProd,
} from '@/services';
import ServiceLocalizeMock from '@/services/rest/mock/localize';
import { ServiceTime } from '@/services/time';
import QueryStore from '@/store/QueryStore';

export type ServiceTypes = 'REST' | 'QUERY' | 'TIME' | 'LOCALIZE';
export type RestServices = 'restDev' | 'restProd' | 'restMock';
export type QueryService = 'query';
export type TimeService = 'time';
export type LocalizeServices = 'localize' | 'localizeMock';

export const serviceTypes: {
  REST: 'REST';
  QUERY: 'QUERY';
  TIME: 'TIME';
  LOCALIZE: 'LOCALIZE';
} = {
  REST: 'REST',
  QUERY: 'QUERY',
  TIME: 'TIME',
  LOCALIZE: 'LOCALIZE',
};

export const restServices: {
  restDev: 'restDev';
  restProd: 'restProd';
  restMock: 'restMock';
} = {
  restDev: 'restDev',
  restProd: 'restProd',
  restMock: 'restMock',
};

export const localizeServices: {
  localize: 'localize';
  localizeMock: 'localizeMock';
} = {
  localize: 'localize',
  localizeMock: 'localizeMock',
};

export const querySerevice: QueryService = 'query';
export const timeService: TimeService = 'time';

export const restServicesMap: {
  [restServices.restDev]: typeof ServiceDev;
  [restServices.restProd]: typeof ServiceProd;
  [restServices.restMock]: typeof ServiceMock;
} = {
  [restServices.restDev]: ServiceDev,
  [restServices.restProd]: ServiceProd,
  [restServices.restMock]: ServiceMock,
};

export const queryServicesMap: {
  [querySerevice]: typeof QueryStore;
} = {
  [querySerevice]: QueryStore,
};

export const timeServiceMap: {
  [timeService]: typeof ServiceTime;
} = {
  [timeService]: ServiceTime,
};

export const localizeServicesMap: {
  [localizeServices.localize]: typeof ServiceLocalizeProd;
  [localizeServices.localizeMock]: typeof ServiceLocalizeMock;
} = {
  [localizeServices.localize]: ServiceLocalizeProd,
  [localizeServices.localizeMock]: ServiceLocalizeMock,
};
